define('modules/editor/views/property_boxes/button_geometry',['require','exports','module','./geometry'],function(require, exports, module){
  "use strict";
  var GeometryPB = require("./geometry");
  module.exports = GeometryPB;
});
